<template>
  <div class="list_ruangan">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-card-title>
              <h3><b>Filter Data Ruangan</b></h3>
            </v-card-title>
            <v-divider></v-divider>

            <v-snackbar
              v-model="$store.getters.snackbar.show"
              multi-line="true"
              top="true"
              color="green"
            >
              {{ snackbar.message }}
              <v-btn
                color="pink"
                flat
                @click="show = false"
              >
                Tutup
              </v-btn>
            </v-snackbar>

            <v-snackbar
              v-model="show2"
              multi-line="true"
              top="true"
              :color="delColor"
            >
              {{ notifMsg }}
              <v-btn
                color="pink"
                flat
                @click="show2 = false"
              >
                Tutup
              </v-btn>
            </v-snackbar>

            <v-card-text>
              <v-form class="px-3">
                <v-layout wrap>
                  <v-flex xs12 lg6>
                    <v-select
                      name="lokasi"
                      label="Lokasi"
                      :items="lokasi"
                      v-model="isiLokasi"
                      @change="onGedung">
                    </v-select>
                    <v-select
                      name="gedung"
                      label="Gedung"
                      :items="gedung"
                      v-model="isiGedung"
                      @change="onRuangan">
                    </v-select>
                  </v-flex>
                  <v-flex xs12 lg6>
                    <v-autocomplete
                      label="Ruangan"
                      :items="kodeRuangan"
                      v-model="isiKode"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-form>
              <v-btn
                class="filter-btn"
                color="deep-orange lighten-1"
                small
                dark
                @click="onfilter"
              >
                <v-icon left>
                  fa fa-filter
                </v-icon>
                Cari
              </v-btn>

              <v-btn
                class="filter-btn"
                color="grey lighten-2"
                small
                @click="onReset"
              >
                <v-icon left>
                  fa fa-repeat
                </v-icon>
                Reset
              </v-btn>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="items"
                item-key="id"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{props.item.namaGedung}}</td>
                  <td>{{ props.item.kodeRuangan }}</td>
                  <td>{{ props.item.namaRuangan }}</td>
                  <td>{{props.item.lantai}}</td>
                  <td>{{ props.item.kapasitasMaksimal }}</td>
                  <td>{{ props.item.namaLokasi }}</td>
                  <td>
                    <v-tooltip bottom>
                      <v-btn slot="activator"
                             depressed
                             icon
                             fab
                             dark
                             color="yellow darken-2"
                             small
                             @click="onView(props.item.id)">
                        <i class="fa fa-search"/>
                      </v-btn>
                      <span>Detail</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <v-btn slot="activator"
                             depressed
                             icon
                             fab
                             dark
                             color="primary"
                             small
                             @click="onEdit(props.item.id)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <span>Ubah</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <v-btn slot="activator"
                             depressed
                             icon
                             fab
                             dark
                             color="red" small @click="onDelete(props.item)">
                        <v-icon>delete</v-icon>
                      </v-btn>
                      <span>Hapus</span>
                    </v-tooltip>

                    <v-dialog
                      v-model="activate"
                      max-width="290"
                    >
                      <v-card>
                        <v-card-title class="headline">Hapus Data Ini?</v-card-title>

                        <v-card-text>
                          Memilih setuju akan menghapus data ruangan dari daftar.
                        </v-card-text>

                        <v-card-actions class="justify-center">
                          <div class="flex-grow-1"></div>

                          <v-btn
                            color="red"
                            text
                            @click="activate = false"
                          >
                            Kembali
                          </v-btn>

                          <v-btn
                            color="primary"
                            text
                            @click="onSubmit()"
                          >
                            Setuju
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-btn 
                  class="btn-tambahRuangan" 
                  color="primary"
                  dark
                  @click="onTambah"
                >
                  <v-icon left>
                    fa fa-plus
                  </v-icon> 
                  Tambah Ruangan
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {base} from "../../setup-axios"
import {createJWT, getJWT} from "../../store/module/helper"
import { mapGetters,  mapActions} from 'vuex'

export default {
      name: "ruangan",
      data() {
         return {
           store: "",
           deleteCMD : {},
           headers: [
             {
               text: "Gedung",
               value: ""
             },
             {
               text: "Kode Ruangan",
               value: "kodeRuangan"
             },
             {
               text: "Nama Ruangan",
               value: "namaRuangan"
             },
             {
               text: "Lantai",
               value: "namaLokasi"
             },
             {
               text: "Kapasitas",
               value: "kapasitasMaksimal"
             },
             {
               text: "Lokasi",
               value: ""
             },
             {
               text: "Aksi",
               value: ""
             }
           ],

           items: [],
           tes: 0,
           delColor: "",
           lokasi : [{value:0,text:"--Pilih Lokasi--"}],
           gedung : [{value:0,text:"--Pilih Gedung--"}],
           kodeRuangan : [{value:null,text:"--Pilih Ruangan--"}],
           isiLokasi : 0,
           isiGedung : 0,
           isiKode : null,
           activate : false,
           show : false,
           show2 : false,
           notifMsg : ''
         }
      },

      created() {
        console.log(this.$store.getters.getMsg)
        this.show = this.checkBool(localStorage.getItem("flag"))
        this.notifMsg = localStorage.getItem("msg")
        let JWT = createJWT()
        console.log(typeof(JWT))

        if(localStorage.getItem("isikode") != null
          || localStorage.getItem("isigedung") != null
          || localStorage.getItem("isiLokasi") != null){

          var url = "ruangan/filter/" + localStorage.getItem("isikode") + "/" + localStorage.getItem("isigedung")
            + "/" + localStorage.getItem("isiLokasi")


          base.get(url,
            {
              headers: {
                'Authorization' : createJWT()
              }
            }
          ).then((resp) => {
            this.items = resp.data.result
          })
        }

        else {
          base.get("ruangan/filter/null/0/0" ,
            {
              headers: {
                'Authorization' : createJWT()
              }
            }).then((resp) => {
            this.items = resp.data.result
          })
            .catch(function(error) {
              console.log('ERROR : ', error)
              console.log('isi dari error', error.response)
            })

        }

        base.get("lokasi/dropdown",
           {
             headers: {
               Authorization: createJWT()
             }
           }).then((resp) => {
          for(var i=0; i < resp.data.result.length;i++){
            this.lokasi.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
          }
        })

        base.get("ruangan/dropdown" ,
          {
            headers: {
              Authorization: createJWT()
            }
          }).then((resp) => {
          for(var i=0; i < resp.data.result.length;i++){
            this.kodeRuangan.push(resp.data.result[i].nama)
          }
        })
      },
  computed:{
    ...mapGetters(["snackbar"]),
    showData:()=>{
      console.log(snackbar.show)
      this.show = this.snackbar.show
    }
  },
      methods: {
        onView (id){
          this.$router.push("/ruangan/view/" + id);
        },
        onTambah (){
          this.$router.push("/ruangan/add");
        },
        onEdit (id){
          this.$router.push("/ruangan/edit/" + id);
        },
        onDelete(item){
          this.deleteCMD = item
          this.activate = true
        },
        onfilter(){
          if(this.isiGedung == null){
            this.isiGedung = 0
          }

          if(this.isiLokasi == null){
            this.isiLokasi = 0
          }

          localStorage.setItem("isikode", this.isiKode)
          localStorage.setItem("isigedung", this.isiGedung)
          localStorage.setItem("isiLokasi", this.isiLokasi)

          var url = "ruangan/filter/" + this.isiKode + "/" + this.isiGedung
                    + "/" + this.isiLokasi

          this.items = []

          base.get(url,
             {
               headers: {
                 'Authorization' : createJWT()
               }
             }
          ).then((resp) => {
            this.items = resp.data.result
          })
        },
        onReset(){
          var url = "ruangan/filter/null/0/0"

          this.items = [{value:0,text:"--Pilih Lokasi--"}]
          this.gedung = [{value:0,text:"--Pilih Gedung--"}]
          this.isiKode = null
          this.isiLokasi = null
          this.isiGedung = null

          localStorage.removeItem("isikode")
          localStorage.removeItem("isigedung")
          localStorage.removeItem("isiLokasi")

          this.onRuangan()

          base.get(url ,
             {
               headers: {
                 'Authorization' : createJWT()
               }
             }
            ).then((resp) => {
            this.items = resp.data.result
          })
        },
        onSubmit(){
          var index = this.items.indexOf(this.deleteCMD)
          let thisVM = this

          base.delete("ruangan/" + this.deleteCMD.id ,
            {
              headers: {
                'Authorization' : createJWT(),
                'token' : getJWT()
              }
            }
            ).then((resp) => {
            console.log('Success');
            console.log(resp.data);
            if(resp.data.status == 200){
              thisVM.show2 = true
              thisVM.delColor = "green"
              thisVM.notifMsg = 'Berhasil Menghapus Data'
              this.items.splice(index, 1)
            }

            if(resp.data.status == 203){
              thisVM.show2 = true
              thisVM.delColor = "red"
              thisVM.notifMsg = 'Ruangan Fungsional Tak Bisa Dihapus'
            }
          }).catch(function(error) {
            console.log('ERROR : ', error)
            console.log('isi dari error', error.response)
            thisVM.show2 = true
            thisVM.notifMsg = 'Gagal Menghapus data'
          })
        },
        onGedung(){
          base.get("gedung/lokasi/" + this.isiLokasi ,
             {
               headers: {
                 Authorization: createJWT()
               }
             }
            ).then((resp) => {
            this.gedung = [{value:0,text:"--Pilih Gedung--"}]

            for(var i=0; i < resp.data.result.length;i++){
              this.gedung.push({value:resp.data.result[i].id,text:resp.data.result[i].nama})
            }
          })
        },
        onRuangan(){
          if(this.isiGedung == 0){
            base.get("ruangan/dropdown" ,
              {
                headers: {
                  Authorization: createJWT()
                }
              }
            ).then((resp) => {
              this.kodeRuangan = [{value:null,text:"--Pilih Ruangan--"}]
              for(var i=0; i < resp.data.result.length;i++){
                this.kodeRuangan.push(resp.data.result[i].nama)
              }
            })
          }

          else {
            base.get("ruangan/dropdown/byGedung/" + this.isiGedung ,
              {
                headers: {
                  Authorization: createJWT()
                }
              }
            ).then((resp) => {
              this.kodeRuangan = [{value:null,text:"--Pilih Ruangan--"}]
              for(var i=0; i < resp.data.result.length;i++){
                this.kodeRuangan.push(resp.data.result[i].nama)
              }
            })
          }
        },
        dataMultiple(data){
          if(data){
            return 'Ya'
          }

          else {
            return 'Tidak'
          }
        },
        checkBool(item){
          if(item == "true"){
            return true
          }
          else {
            return false
          }
        }
      }
    }
</script>

<style scoped>

</style>